(function () {
  'use strict';

  angular
    .module('app')
    .component(
      'bookingItemServiceItemStandardCostBased',
      bookingItemServiceItemStandardCostBased()
    );

  function bookingItemServiceItemStandardCostBased() {
    return {
      bindings: {
        bookingItemServiceItem: '<',
        bookingItem: '<',
        booking: '<',
        documentDateExchangeRate: '<',
        onBookingItemServiceItemStandardCostBasedSaved: '&',
      },
      controller: BookingItemServiceItemStandardCostBasedCtrl,
      controllerAs: 'vm',
      templateUrl:
        './app/ajs/bookings/booking-items/booking-item-service-items/components/' +
        'booking-item-service-item-standard-cost-based/booking-item-service-item-standard-cost-based.component.html',
    };
  }

  BookingItemServiceItemStandardCostBasedCtrl.$inject = [
    'UtilService',
    'moment',
    'ServiceItemService',
    'TaxService',
    'ExchangeRateService',
  ];

  function BookingItemServiceItemStandardCostBasedCtrl(
    UtilService,
    moment,
    ServiceItemService,
    TaxService,
    ExchangeRateService
  ) {
    var vm = this;

    vm.UtilService = new UtilService(vm);

    // Methods
    vm.selectAssociatedProvider = selectAssociatedProvider;
    vm.saveBookingItemServiceItemStandardCostBased = saveBookingItemServiceItemStandardCostBased;

    vm.$onInit = function () {
      vm.loadingAvailability = true;

      vm.currencySymbol = vm.booking.currency.symbol;
      vm.decimalPlaces = vm.booking.currency.decimal_places;

      vm.originalBookingItemServiceItemProviderId = angular.copy(
        vm.bookingItemServiceItem.provider_id
      );
      vm.associatedProviderSelectedId = vm.originalBookingItemServiceItemProviderId;
      vm.associatedProviderSelected = null;

      getServiceItem();
    };

    function getServiceItem() {
      var params = {
        costs: false,
        taxes: true,
        skip_check_role: true,
      };

      ServiceItemService.getServiceItem(vm.bookingItemServiceItem.service_item_id, params).then(
        function (data) {
          vm.product = data;

          let associatedProviders = data.associated_providers.filter(
            (associatedProvider) => associatedProvider.status
          );
          vm.associatedProviders = angular.copy(associatedProviders);

          vm.productCostType = vm.product.cost_type;

          setProvidersCostAndPrices();
        }
      );
    }

    let applyExchangeRateConversion = (amount) =>
      ExchangeRateService.applyExchangeRateConversion(amount, vm.documentDateExchangeRate);

    // Set product costs/prices for a provider
    function setProvidersCostAndPrices() {
      vm.providerTableWidth = 100 / vm.associatedProviders.length;

      if (vm.bookingItemServiceItem.providerCosts) {
        vm.bookingItemServiceItem.providerCosts.forEach(function (providerCost) {
          // Provider has costs
          if (providerCost.costs) {
            for (let i = 0; i < vm.associatedProviders.length; i++) {
              let associatedProvider = vm.associatedProviders[i];

              if (associatedProvider.provider_id === providerCost.provider_id) {
                associatedProvider.has_costs = true;

                // if (vm.bookingItemServiceItem.service_item.cost_type === 'per_person'){
                if (vm.productCostType === 'per_person') {
                  associatedProvider.adult_cost = applyExchangeRateConversion(
                    providerCost.costs.adult_cost
                  );
                  associatedProvider.adults_cost =
                    vm.bookingItemServiceItem.adults * associatedProvider.adult_cost;
                  // associatedProvider.adults_profit   = vm.bookingItemAdultsPrice - associatedProvider.adults_cost;

                  associatedProvider.child_cost = applyExchangeRateConversion(
                    providerCost.costs.child_cost
                  );
                  associatedProvider.children_cost =
                    vm.bookingItemServiceItem.children * associatedProvider.child_cost;
                  // associatedProvider.children_profit = vm.bookingItemChildrenPrice - associatedProvider.children_cost;

                  associatedProvider.infant_cost = applyExchangeRateConversion(
                    providerCost.costs.infant_cost
                  );
                  associatedProvider.infants_cost =
                    vm.bookingItemServiceItem.infants * associatedProvider.infant_cost;
                  // associatedProvider.infants_profit  = vm.bookingItemInfantsPrice - associatedProvider.infants_cost;

                  associatedProvider.senior_cost = applyExchangeRateConversion(
                    providerCost.costs.senior_cost
                  );
                  associatedProvider.seniors_cost =
                    vm.bookingItemServiceItem.seniors * associatedProvider.senior_cost;
                  // associatedProvider.seniors_profit  = vm.bookingItemSeniorsPrice - associatedProvider.seniors_cost;

                  associatedProvider.item_cost =
                    associatedProvider.adults_cost +
                    associatedProvider.children_cost +
                    associatedProvider.infants_cost +
                    associatedProvider.seniors_cost;
                } else {
                  associatedProvider.item_cost = applyExchangeRateConversion(
                    providerCost.costs.service_cost
                  );
                }

                break;
              }
            }
          }
        });

        vm.lowestCostProviderId = vm.UtilService.getLowestItemValueFromArray(
          vm.associatedProviders,
          'item_cost'
        ).id;
      }

      vm.loadingAvailability = false;
    }

    function selectAssociatedProvider(associatedProvider) {
      vm.associatedProviderSelectedId = associatedProvider.provider_id;
      vm.associatedProviderSelected = associatedProvider;

      saveBookingItemServiceItemStandardCostBased();
    }

    function saveBookingItemServiceItemStandardCostBased() {
      // let confirmCallback = () => {
      vm.bookingItemServiceItem.provider_id = vm.associatedProviderSelectedId;
      vm.bookingItemServiceItem.provider = vm.associatedProviderSelected.provider;

      var documentDate = moment(vm.booking.created_at);

      let productPurchaseTaxes = TaxService.setProductTaxes(vm.product, documentDate).purchaseTaxes; // , vm.taxes TODO: vm.bookingItemServiceItem.purchase_taxes ???

      if (vm.productCostType === 'per_person') {
        vm.bookingItemServiceItem.adult_cost = vm.associatedProviderSelected.adult_cost;
        vm.bookingItemServiceItem.child_cost = vm.associatedProviderSelected.child_cost;
        vm.bookingItemServiceItem.infant_cost = vm.associatedProviderSelected.infant_cost;
        vm.bookingItemServiceItem.senior_cost = vm.associatedProviderSelected.senior_cost;
      }

      let item_cost = vm.associatedProviderSelected.item_cost;
      let base_cost = TaxService.setBaseCostPrice(
        vm.bookingItemServiceItem.item_cost,
        vm.bookingItemServiceItem.price_list,
        productPurchaseTaxes
      );
      let net_cost = base_cost;
      let pickup_cost = 0;
      let dropoff_cost = 0;
      let discount_cost = 0;
      let subtotal_cost = net_cost + pickup_cost + dropoff_cost - discount_cost;
      let tax_cost_percentage = TaxService.getProductTaxesTotalPercentage(productPurchaseTaxes);

      vm.bookingItemServiceItem.purchase_taxes = TaxService.setProductTaxesAmounts(
        subtotal_cost,
        productPurchaseTaxes
      );

      let tax_cost = TaxService.getProductTaxesTotalAmount(
        vm.bookingItemServiceItem.purchase_taxes
      );
      let total_cost = subtotal_cost + tax_cost;

      vm.bookingItemServiceItem.item_cost = vm.UtilService.roundNum(item_cost);
      vm.bookingItemServiceItem.base_cost = vm.UtilService.roundNum(base_cost);
      vm.bookingItemServiceItem.net_cost = vm.UtilService.roundNum(net_cost);
      vm.bookingItemServiceItem.discount_cost = vm.UtilService.roundNum(discount_cost); // conversion needed *
      vm.bookingItemServiceItem.subtotal_cost = vm.UtilService.roundNum(subtotal_cost);
      vm.bookingItemServiceItem.tax_cost_percentage = tax_cost_percentage;
      vm.bookingItemServiceItem.tax_cost = vm.UtilService.roundNum(tax_cost);
      vm.bookingItemServiceItem.total_cost = vm.UtilService.roundNum(total_cost);

      vm.onBookingItemServiceItemStandardCostBasedSaved({
        bookingItemServiceItem: vm.bookingItemServiceItem,
      });
    }
  }
})();
